var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMenu = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillOpacity: 0.5,
  d: "M19.958 2h-5.455c-.88 0-1.592.712-1.592 1.591v5.456c0 .879.713 1.591 1.592 1.591h5.455c.88 0 1.592-.712 1.592-1.591V3.591c0-.879-.713-1.591-1.592-1.591M21.535 16.106l-3.18-3.18a1.594 1.594 0 0 0-2.25 0l-3.178 3.18a1.593 1.593 0 0 0 0 2.25l3.178 3.179a1.593 1.593 0 0 0 2.25 0l3.18-3.18a1.59 1.59 0 0 0 0-2.25M9.047 2H3.59C2.712 2 2 2.712 2 3.591v5.456c0 .879.712 1.591 1.591 1.591h5.456c.879 0 1.591-.712 1.591-1.591V3.591C10.638 2.712 9.926 2 9.047 2M9.047 12.912H3.59c-.879 0-1.591.712-1.591 1.59v5.457c0 .878.712 1.59 1.591 1.59h5.456c.879 0 1.591-.712 1.591-1.59v-5.456c0-.88-.712-1.591-1.591-1.591"
})));
export default SvgMenu;